import { render, staticRenderFns } from "./NewCompte.vue?vue&type=template&id=4265deaa&"
import script from "./NewCompte.vue?vue&type=script&lang=js&"
export * from "./NewCompte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports